import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const InvalidEmailModal = (props: AlertProps) => (
    <Alert
        {...props}
        title="Ошибка в адресе электронной почты"
        description="Проверьте, пожалуйста, адрес электронной почты и убедитесь, что он введён корректно."
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
